import { type TopBannerProps } from './TopBannerProps'

export const TopBannerDefaults = {
  children: '',
  backgroundColor: 'var(--color-bodi-accent-bright-500)',
  textColor: '#000',
  height: undefined,
  isSticky: false,
} satisfies TopBannerProps
